<template>
  <div
    v-if="selectedResidence"
    class="appHeaderCard"
  >
    <img
      class="appHeaderCard__img"
      src="../../assets/images/layout/image.png"
    />
    <div class="appHeaderCard__card">
      <div
        class="appHeaderCard__content"
        :class="{ opened: opened }"
      >
        <img
          class="appHeaderCard__preview"
          :class="{ update: hasUpdates }"
          :src="imageFromArpej"
        />
        <div class="appHeaderCard__decorator">
          <i class="el-icon-folder-opened el-icon--left"></i>
          <folder-card :opened="opened" />
        </div>
        <div class="appHeaderCard__decorator">
          <i class="el-icon-s-home el-icon--left"></i>
          <div>
            <residence-card :opened="opened" />
            <selected-accomodation-card v-if="opened" />
          </div>
        </div>
        <div class="appHeaderCard__progress">
          <div v-if="currentRecord && currentRecord.progress">
            <p>{{ $t('residences.folderCard.state') }}</p>
            <div>
              <el-progress
                class="appHeaderCard__progress--loadingBar"
                :show-text="false"
                :percentage="currentRecord.progress"
              ></el-progress>
              <span>{{ currentRecord.state_label }}</span>
              <div
                v-if="currentRecord.state==='created'"
                class="appHeaderCard__progress--created"
              >{{$t('residences.folderCard.createdState')}}</div>
            </div>
          </div>
        </div>
        <div
          class="appHeaderCard__button"
          @click="opened = !opened"
        >
          <el-tooltip
            :content="
              $t('residences.accomodation.see') +
                ' ' +
                (opened
                  ? $t('residences.accomodation.less')
                  : $t('residences.accomodation.more'))
            "
            placement="bottom"
            effect="light"
          >
            <i
              v-if="!opened"
              class="el-icon-arrow-down"
            />
            <i
              v-if="opened"
              class="el-icon-arrow-up"
            />
          </el-tooltip>
        </div>
      </div>
      <div
        v-if="hasUpdates"
        class="appHeaderCard__updates"
      >
        <p>{{ $t('records.grid.modifyState') }}</p>
        <el-button
          type="primary"
          @click="dialogVisible = true"
        >{{ $t('records.grid.update') }}</el-button>
      </div>
      <record-dialog
        v-if="dialogVisible"
        :visible="dialogVisible"
        :record-id="currentRecord.id"
        @close="dialogVisible = false"
      />
    </div>
  </div>
</template>

<script>
import ResidenceCard from '@/components/layout/cards/ResidenceCard'
import SelectedAccomodationCard from '@/components/layout/cards/SelectedAccomodationCard'
import FolderCard from '@/components/layout/cards/FolderCard'
import RecordDialog from '@/components/records/RecordDialog'
import { mapState } from 'vuex'

export default {
  name: 'AppHeaderCard',
  components: {
    ResidenceCard,
    SelectedAccomodationCard,
    FolderCard,
    RecordDialog
  },
  data: () => ({
    opened: false,
    dialogVisible: false
  }),
  computed: {
    ...mapState({
      currentRecord: state => state.records.currentRecord,
      selectedResidence: state => state.residences.selectedResidence
    }),
    hasUpdates() {
      return this.currentRecord ? [
        'processing_missing_documents',
        'processing_missing_guarantors',
        'granted_waiting_price_acceptation'
      ].includes(this.currentRecord.state) : false
    },
    imageFromArpej() {
      return this.selectedResidence.pictures &&
        this.selectedResidence.pictures.length > 0
        ? this.selectedResidence.pictures[0].url
        : 'https://www.arpej.fr/wp-content/uploads/2015/06/DSC01264.jpg'
    }
  },
  watch: {
    'currentRecord.id': {
      handler(newVal, oldVal) {
        if (newVal && this.isWaitingPrice) {
          this.dialogVisible = true
        }
      }
    }
  },
  mounted() {
    if (this.currentRecord && this.isWaitingPrice) {
      this.dialogVisible = true
    }
  }
}
</script>

<style lang="scss" scoped>
$c: '.appHeaderCard';

#{$c} {
  display: flex;
  justify-content: left;
  margin-bottom: 10px;

  &__img {
    position: absolute;
    height: 125px;
    width: auto;

    @include respond-below(lg) {
      display: none;
    }
  }

  &__card {
    position: relative;
    font-size: 14px;
    width: 100%;
    margin: 0 10px;
    overflow: hidden;
    box-shadow: 0 2px 12px 0 rgba(175, 175, 175, 0.5);

    @include respond-above(sm) {
      margin: 0 7%;
    }

    @include respond-above(lg) {
      margin: 20px 7% 0 7%;
      border-radius: 23px;
    }
  }

  &__content {
    display: flex;
    justify-content: space-between;
    flex-direction: column;

    @include respond-above(lg) {
      text-align: center;
      height: 85px;
      display: grid;
      grid-template-columns: 155px repeat(2, 1fr) minmax(200px, 350px) 70px;
      &.opened {
        height: 320px;
      }
    }

    & > div {
      margin: 5px 20px;

      p {
        font-size: 12px;
        font-weight: bold;
        line-height: 30px;
        color: #303133;
        text-transform: uppercase;
        max-width: 65px;
        margin: 0;
        @include respond-above(lg) {
          max-width: 100%;
        }
      }
    }
  }

  &__decorator {
    display: flex;
    align-items: center;

    @include respond-above(lg) {
      display: block;
      border-top: 2px solid #f4b452;
      margin: 25px 2% 0 2% !important;
      max-width: 325px;
    }
    @include respond-above(xl) {
      margin: 25px 5% 0 5% !important;
    }

    i {
      background-color: #ffffff;
      padding: 0 10px;
      font-size: 30px;
      @include respond-above(lg) {
        margin-top: -15px;
        padding: 0 20px;
      }
    }
  }

  &__preview {
    height: 85px;
    width: 155px;
    object-fit: cover;
    border-radius: 23px 0 0 23px;

    &.update {
      border-radius: 23px 0 0 0;
    }

    @include respond-below(lg) {
      display: none;
    }
  }
  .opened &__preview {
    height: 320px;
  }

  &__progress {
    min-width: 145px;
    display: flex;
    align-items: center;

    @include respond-below(lg) {
      & > div {
        display: flex;
        align-items: center;
      }
    }

    @include respond-between(xs, lg) {
      & > div > div {
        margin-left: 20px;
      }
    }

    @include respond-above(lg) {
      display: block;
    }

    &--loadingBar {
      margin-bottom: 5px;
    }
    & span {
      font-weight: bold;
    }
    &--created {
      font-size: 12px;
      margin-right: 30px;

      @include respond-above(lg) {
        margin-right: 0;
      }
    }
  }

  &__button {
    font-size: 20px;
    padding-top: 10px;
    cursor: pointer;
    text-align: right;
    position: absolute;
    right: 0;
    bottom: 0;
    margin: 0 10px;

    @include respond-above(lg) {
      font-size: 50px;
      position: relative;
      margin: 0 20px;
    }
  }

  &__updates {
    border-top: solid 1px #e4e7ed;
    padding: 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: space-between;

    p {
      color: #909399;
      padding-right: 5px;
    }
  }
}
</style>
